import { render, staticRenderFns } from "./ManageStock.vue?vue&type=template&id=6c0af66b&scoped=true&"
import script from "./ManageStock.vue?vue&type=script&lang=js&"
export * from "./ManageStock.vue?vue&type=script&lang=js&"
import style0 from "./ManageStock.vue?vue&type=style&index=0&id=6c0af66b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0af66b",
  null
  
)

export default component.exports